import React from 'react';
import { connect } from 'react-redux';
import { Row } from 'antd';
import Nav from '../components/Nav';

export default connect(store => store)(props => (
  <div>
    <Nav />
    <div className="ProfileContainer">
      <Row span={12} style={{ marginLeft: '20%', marginTop: 50, width: '50%' }}>
        <p>Username: {props.user.username}</p>
        <p>Email: {props.user.email}</p>
        <p>Status: Premium</p>
      </Row>
    </div>
  </div>
));



// WEBPACK FOOTER //
// ./src/user/Profile.js